import { Link } from "react-router-dom";
import type { ShortStory } from "@/mocks/narutoContent";

export default function StoryCard({ story, index }: { story: ShortStory; index: number }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-shadow hover:shadow-soft sm:flex-row">
      <Link to={`/duanpian/${story.id}`} className="relative block overflow-hidden sm:w-2/5" aria-label={story.title}>
        <img
          src={story.cover}
          alt={`${story.title} 火影忍者同人短篇插画`}
          title={`${story.title} · 火影忍者同人短篇`}
          loading="lazy"
          className="h-44 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 sm:h-full"
        />
        <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 font-label text-xs text-background-50">
          短篇速读
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-6">
        <div className="flex items-center gap-2 font-label text-xs text-foreground-500">
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-secondary-800">{story.category}</span>
          <span className="inline-flex items-center gap-1"><i className="ri-time-line"></i>{story.readTime}</span>
        </div>
        <h3 className="mt-3 font-display text-2xl text-foreground-950 leading-snug">
          <Link to={`/duanpian/${story.id}`} className="hover:text-primary-700 transition-colors">{story.title}</Link>
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{story.summary}</p>
        <div className="mt-4 flex items-center justify-between">
          <span className="inline-flex items-center gap-1 font-label text-xs text-foreground-500">
            <i className="ri-account-circle-line text-base"></i>{story.author}
          </span>
          <span className="inline-flex items-center gap-1 font-label text-sm text-primary-600 group-hover:text-primary-700">
            开始阅读 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
          </span>
        </div>
      </div>
      <span className="sr-only">第 {index + 1} 篇</span>
    </article>
  );
}